import React, { useState } from 'react';
import { Navbar } from '../components/layouts/Navbar';
import { PlannerSidebar } from '../components/layouts/PlannerSidebar';
import { EmpresaTable } from '../components/empresa/EmpresaTable';
import { GrupoTable } from '../components/grupo/GrupoTable';
import { UsuarioTable } from '../components/usuario/UsuarioTable';
import { EmpresaModal } from '../components/empresa/EmpresaModal';
import { GrupoModal } from '../components/grupo/GrupoModal';
import { UsuarioModal } from '../components/usuario/UsuarioModal';
import { useAuthSimple } from '../hooks/useAuth';
import type { Grupo, Empresa, Usuario } from '../types/entities';

const CadastroEmpresaGrupo: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'empresas' | 'grupos' | 'usuarios'>('empresas');
  // Estados para modais
  const [empresaModalOpen, setEmpresaModalOpen] = useState(false);
  const [grupoModalOpen, setGrupoModalOpen] = useState(false);
  const [usuarioModalOpen, setUsuarioModalOpen] = useState(false);
  const [editingEmpresa, setEditingEmpresa] = useState<Empresa | null>(null);
  const [editingGrupo, setEditingGrupo] = useState<Grupo | null>(null);
  const [editingUsuario, setEditingUsuario] = useState<Usuario | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);



  const { user } = useAuthSimple();

  // Função para forçar refresh das tabelas
  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  // Funções para abrir modais
  const handleNewEmpresa = () => {
    setEditingEmpresa(null);
    setEmpresaModalOpen(true);
  };

  const handleEditEmpresa = (empresa: Empresa) => {
    setEditingEmpresa(empresa);
    setEmpresaModalOpen(true);
  };

  const handleNewGrupo = () => {
    setEditingGrupo(null);
    setGrupoModalOpen(true);
  };

  const handleEditGrupo = (grupo: Grupo) => {
    setEditingGrupo(grupo);
    setGrupoModalOpen(true);
  };

  const handleNewUsuario = () => {
    setEditingUsuario(null);
    setUsuarioModalOpen(true);
  };

  const handleEditUsuario = (usuario: Usuario) => {
    setEditingUsuario(usuario);
    setUsuarioModalOpen(true);
  };

  if (!user || user.type !== 'master') {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#F4EFFA' }}>
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-2" style={{ color: '#3d2b56' }}>
            Acesso Negado
          </h1>
          <p style={{ color: '#9E9E9E' }}>Apenas usuários master podem acessar esta página.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-50">
      <Navbar />
      <div className="container mx-auto px-4 py-8">
        <div className="flex gap-6">
          <div className="flex-1">
            {/* Abas de navegação modernizadas */}
            <div className="bg-white rounded-xl shadow-lg mb-6 overflow-hidden">
              <div className="flex border-b border-gray-200">

                <button
                  onClick={() => setActiveTab('empresas')}
                  className={`flex items-center px-6 py-4 font-medium text-sm transition-all duration-200 ${
                    activeTab === 'empresas'
                      ? 'text-purple-600 bg-purple-50 border-b-2 border-purple-600'
                      : 'text-gray-600 hover:text-purple-600 hover:bg-gray-50'
                  }`}
                >
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 0v12h8V4H6z" clipRule="evenodd" />
                  </svg>
                  Empresas
                </button>
                <button
                  onClick={() => setActiveTab('grupos')}
                  className={`flex items-center px-6 py-4 font-medium text-sm transition-all duration-200 ${
                    activeTab === 'grupos'
                      ? 'text-purple-600 bg-purple-50 border-b-2 border-purple-600'
                      : 'text-gray-600 hover:text-purple-600 hover:bg-gray-50'
                  }`}
                >
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Grupos
                </button>
                <button
                  onClick={() => setActiveTab('usuarios')}
                  className={`flex items-center px-6 py-4 font-medium text-sm transition-all duration-200 ${
                    activeTab === 'usuarios'
                      ? 'text-purple-600 bg-purple-50 border-b-2 border-purple-600'
                      : 'text-gray-600 hover:text-purple-600 hover:bg-gray-50'
                  }`}
                >
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                  </svg>
                  Usuários
                </button>
              </div>
            </div>

            {/* Conteúdo das abas */}
            <div className="mt-6">

          {/* Aba Lista de Empresas */}
          {activeTab === 'empresas' && (
            <div className="space-y-6">
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className="bg-gradient-to-r from-blue-500 to-cyan-600 rounded-full p-3 mr-4">
                      <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 0v12h8V4H6z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div>
                      <h2 className="text-xl font-bold text-gray-800">
                        Empresas Cadastradas
                      </h2>
                      <p className="text-gray-600 text-sm">
                        Visualize e gerencie todas as empresas do sistema
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={handleNewEmpresa}
                    className="flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-medium rounded-xl shadow-lg hover:from-blue-700 hover:to-cyan-700 transition-all duration-200 transform hover:scale-105"
                  >
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                    </svg>
                    Nova Empresa
                  </button>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <EmpresaTable 
                  onEdit={handleEditEmpresa}
                  onRefresh={handleRefresh}
                />
              </div>
            </div>
          )}

          {/* Aba Lista de Grupos */}
          {activeTab === 'grupos' && (
            <div className="space-y-6">
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className="bg-gradient-to-r from-purple-500 to-pink-600 rounded-full p-3 mr-4">
                      <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div>
                      <h2 className="text-xl font-bold text-gray-800">
                        Grupos Organizacionais
                      </h2>
                      <p className="text-gray-600 text-sm">
                        Gerencie grupos e suas empresas associadas
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={handleNewGrupo}
                    className="flex items-center px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-medium rounded-xl shadow-lg hover:from-purple-700 hover:to-pink-700 transition-all duration-200 transform hover:scale-105"
                  >
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                    </svg>
                    Novo Grupo
                  </button>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <GrupoTable 
                  onEdit={handleEditGrupo}
                  onRefresh={handleRefresh}
                />
              </div>
            </div>
          )}

          {/* Aba Lista de Usuários */}
          {activeTab === 'usuarios' && (
            <div className="space-y-6">
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className="bg-gradient-to-r from-purple-500 to-indigo-600 rounded-full p-3 mr-4">
                      <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                      </svg>
                    </div>
                    <div>
                      <h2 className="text-xl font-bold text-gray-800">
                        Usuários do Sistema
                      </h2>
                      <p className="text-gray-600 text-sm">
                        Gerencie usuários, permissões e acessos
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={handleNewUsuario}
                    className="flex items-center px-6 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-medium rounded-xl shadow-lg hover:from-purple-700 hover:to-indigo-700 transition-all duration-200 transform hover:scale-105"
                  >
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                    </svg>
                    Novo Usuário
                  </button>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <UsuarioTable onEdit={handleEditUsuario} onRefresh={handleRefresh} />
              </div>
            </div>
          )}
            </div>
          </div>

          {/* Sidebar */}
          <div className="w-80 hidden lg:block">
            <PlannerSidebar />
          </div>
        </div>

        {/* Modais */}
        <EmpresaModal
          isOpen={empresaModalOpen}
          onClose={() => setEmpresaModalOpen(false)}
          onSuccess={handleRefresh}
          empresa={editingEmpresa}
        />
        
        <GrupoModal
          isOpen={grupoModalOpen}
          onClose={() => setGrupoModalOpen(false)}
          onSuccess={handleRefresh}
          grupo={editingGrupo}
        />
        
        <UsuarioModal
          isOpen={usuarioModalOpen}
          onClose={() => setUsuarioModalOpen(false)}
          onSuccess={handleRefresh}
          usuario={editingUsuario}
        />
      </div>
    </div>
  );
};

export default CadastroEmpresaGrupo;